const selfTrainingReport = {
  self_training_report: `Informe De Autoentrenamiento`,
  "ReTrain Overview": `Descripción general de ReTrain`,
  "Top 10 Tag Names (By Training Counts)": `Los 10 nombres de etiquetas más populares (según el conteo de entrenamiento)`,
  "Retrained Models": `Modelos reentrenados`,
  "Tag Name": `Nombre de etiqueta`,
};
export default selfTrainingReport;
